<template>

  <t-page>

    <UserChangePasswordDialog :user-id="modalUserId" :enable-access-code="modalEnableAccessCode" :name="modalNameUser"
                              :no-option-add="noOptionAdd" @onSubmit="onChangePasswordDialog"/>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">



      <template #search>
        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <t-input-search v-model="form.profileId" :options="profileAllOptions" label="Perfil de Acesso" select/>

          <t-input-search v-model="form.groupUserId" :options="groupUserOptions" label="Grupo" select/>

          <t-input-search v-model="form.enableExternalAccess" boolean text-true="Liberados" text-false="Restritos" label="Acesso Externo"></t-input-search>

        </t-content-header-search-default>

      </template>

      <b-table hover :items="request.content" v-if="checkViewListTableDefault()" :busy="!pageListIsLoaded"
               :fields="fields">

        <template #cell(first)="{item}">

          <t-list-link-primary :label="item.name" :userAuth="userAuth" :id="item.userNumber"
                               :path="currentPage.path"/>
          <i class="fa fa-fw text-warning ml-2" v-if="item.typeMaster" v-b-tooltip.hover title="Usuário Master"></i>

        </template>

        <template #cell(status)="{item}">
          {{ item.status | statusLabel }}
        </template>

        <template #cell(lastAccessDate)="{item}">
          {{ item.lastAccessDate | datetime }}
        </template>

        <template #cell(groupsUser)="{item}">

          <span v-if="item.groupsUser !== '' && item.groupsUser">{{ item.groupsUser }}</span>
          <small v-else>Nenhum grupo vinculado</small>

        </template>


        <template #cell(enableExternalAccess)="{item}">

          <span v-if="item.enableExternalAccess" class="text-danger" v-b-tooltip.hover
                title="Usuário sem restrição de acesso via IP com maior risco de segurança">Liberado Externo</span>
          <span v-else class="text-success">Rede interna</span>
        </template>


        <template #cell(actions)="{item}">

          <t-button v-if="!item.typeMaster" small
                    @click="openDialogChangePassword(item.userId,item.name, item.enableAccessCode)">
            <b-icon-lock></b-icon-lock>
            Trocar senha
          </t-button>

          <t-list-actions-default :form-path="currentPage.path" :disable-delete="item.typeMaster" :id="item.userNumber"
                                  :userAuth="userAuth"/>
        </template>

      </b-table>

      <t-msg v-else warning>{{ t('no-record-found') }}</t-msg>

    </t-page-list>

  </t-page>

</template>
<script>
import UserChangePasswordDialog from "@/views/modules/admin/UserChangePasswordDialog"
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import ui from "@/assets/scripts/ui";
import http from "@/services/config/http-common";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'User',
  components: {UserChangePasswordDialog},
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      form: {
        groupUserId: 0,
        enableExternalAccess: null,
      },
      fields: [
        {key: "first", label: "Nome"},
        {key: "enableExternalAccess", label: "Acesso"},
        {key: "profile", label: "Perfil de Acesso"},
        {key: "groupsUser", label: "Grupo"},
        {key: "lastAccessDate", label: "Último Login"},
        {key: "actions", label: ""},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      profileAllOptions: [],
      groupUserOptions:[],
      noOptionAdd: "",
      modalUserId: 0,
      modalEnableAccessCode: false,
      modalNameUser: "",
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


      await http.list("admin/user/selectRelationList").then((response) => {

        this.profileAllOptions = response.profileAllOptions
        this.groupUserOptions = response.groupUserOptions

      }).catch(error => this.responseError(error))


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openDialogChangePassword(userId, name, enableAccessCode) {
      this.modalUserId = userId
      this.modalNameUser = name
      this.modalEnableAccessCode = enableAccessCode
      this.openDialogForm('modal-user-change-password')
    },
    onChangePasswordDialog() {
      ui.toast(this, "Senha alterada!", "Senha do usuário alterada com sucesso")
    },
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
